import { CONVERSATIONS_REGEX } from './constants'

export function conversationIdFromPathname(pathname) {
  const result = CONVERSATIONS_REGEX.exec(pathname)

  if (result && result[2]) {
    return parseInt(result[2])
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/helpers.js